import { Box } from "@mui/material";
import { useContext } from "react";
import { LanguageContext } from "../../../context/LanguageContext";
import { ParagraphText } from "../../../Libraries";
import styles from "./SearchSkeleton.module.css";

const SKELETON_COUNT = 1;

const SearchSkeleton = () => {
  const [I18n] = useContext(LanguageContext);
  return (
  <Box className={styles.skeletonContainer}>
    <ParagraphText className={`fontSize13 newLightColor ${styles.searchingLabel}`}>
      {I18n.searching || "Searching"}
    </ParagraphText>
    {[...Array(SKELETON_COUNT)].map((_, i) => (
      <Box key={i} className={styles.skeletonRow}>
        <Box className={styles.skeletonAvatar} />
        <Box className={styles.skeletonTextGroup}>
          <Box className={`${styles.skeletonLine} ${styles.skeletonLong}`} />
        </Box>
        <Box className={`${styles.skeletonLine} ${styles.skeletonShort}`} />
      </Box>
    ))}
  </Box>
  );
};

export default SearchSkeleton;
